import fetch from "cross-fetch";
import _ from "lodash";
import log from "loglevel";
import queryString from "qs";
import cookie from "js-cookie";

const DOMAIN = process.env.VUE_APP_API_SHARE_DOMAIN || "/";

/**
 * api
 *
 * @param  {} {method='GET'
 * @param  {} path
 * @param  {} id=''
 * @param  {} postEndPoint=''
 * @param  {} body={}
 * @param  {} queryParams={}
 * @param  {} endpoint=''
 * @param  {} locale='jp'}
 */
export default ({
  method = "GET",
  path,
  directUrl,
  id = "",
  postEndPoint = "",
  body = {},
  queryParams = {},
  endpoint = "",
  contetType,
  locale
}) => {
  const headers = {
    "X-CSRF-Token": cookie.get("XSRF-TOKEN") || "",
    "Content-Type": contetType || "application/json; charset=utf-8"
  };

  if (!locale) {
    const match = window.location.pathname.split("/");
    locale = match[1] || "ja-jp";
  }

  const credentials = {
    mode: "cors"
  };

  if (!directUrl) {
    credentials.credentials = "include";
  }

  const getRequest = method => {
    switch (method) {
      case "GET":
      case "DELETE":
        return { method, headers, ...credentials };
      case "POST":
      case "PUT":
        return { method, body: JSON.stringify(body), headers, ...credentials };
      default:
        log.error(`method no match error:${method}`);
        return {};
    }
  };
  log.debug("env:", process.env);
  let apiPath = `${DOMAIN}${locale}/${path}/web-api/${endpoint}`;

  if (directUrl) {
    apiPath = directUrl;
  } else {
    if (id) {
      apiPath += "/" + id;
    }

    if (postEndPoint !== "") {
      apiPath += `/${postEndPoint}`;
    }

    if (_.size(queryParams)) {
      apiPath += `?${queryString.stringify(queryParams)}`;
    }
    log.debug("body:", body);
    log.debug("apiPath:", apiPath);
  }

  return fetch(apiPath, getRequest(method))
    .then(async response => {
      const contentType = response.headers.get("content-type");
      // 200じゃない場合はスロー
      if (!response.ok) {
        throw response;
      }

      if (contentType && contentType.includes("application/json")) {
        const json = await response.json();
        //status コードが 0 以外の場合はエラー
        if (json.status !== 0) {
          throw json;
        }
        return json;
      } else {
        return response;
      }
    })
    .catch(function(ex) {
      log.error("error response:", ex);

      throw ex;
    });
};
